/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import React, { ReactElement } from "react";

import { useAuth } from "Authentication/AuthProvider";

import Navigation from "../../Components/Navigation/Navigation";

const NavigationContainer = (): ReactElement => {
  const { isUserLoggedIn, onSignIn, onSignOut } = useAuth();

  return (
    <Navigation
      isUserAuthenticated={isUserLoggedIn}
      onSignInClicked={onSignIn}
      onSignOutClicked={onSignOut}
    />
  );
};

export default NavigationContainer;
